var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.412,
    height: 9.414,
    viewBox: "0 0 9.412 9.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(-7179.689 328.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M4428.15,47l4,4-4,4",
    transform: "translate(11616.545 -273) rotate(180)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M7178.689-328v9.41",
    transform: "translate(2 -0.703)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.5d01aada2691441e451ffb8b3440e5fe.svg";
export { ForwardRef as ReactComponent };